import React, { useState, useEffect } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { VscCloudDownload } from "react-icons/vsc";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import {
  getLoginUser,
  reset,
} from "../../../features/Registration/registrationSlice";
import { headerTitles } from "../../../components/JobInputData";
import swal from "sweetalert";
import Pagination from "../../../components/Pagination";
import { EntriesPerPage } from "../../../components/TableOptions";
import { Toaster } from "react-hot-toast";

const RoleTable = ({ pageHeader, setDataUser }: any) => {
  const dispatch = useAppDispatch();
  const {
    dataLoginUser,
    isErrorLoginUser,
    messageLoginUser,
    isLoadingLoginUser,
  } = useAppSelector((state: { registration: any }) => state.registration);

  const [active, setActive] = useState<any[]>([]);



  useEffect(() => {
    dispatch(getLoginUser());
  }, [dispatch]);


  useEffect(() => {
    setActive([dataLoginUser?.currentUser]);
  }, [dataLoginUser?.currentUser]);

  useEffect(() => {
    if (isErrorLoginUser) {
      swal({
        title: "error",
        text: messageLoginUser,
        // @ts-ignor
        icon: "error",
      });
      dispatch(reset());
    }
  }, [dispatch, isErrorLoginUser, messageLoginUser]);

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  useEffect(() => {
    setDataUser([dataLoginUser?.currentUser?.length]);
  }, [dataLoginUser?.currentUser?.length, setDataUser]);

  const [displayData, setDisplayData] = useState<any[]>([]);

  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <input className="search__input" type="text" placeholder="Search" />
            <div>
              <EntriesPerPage
                data={[dataLoginUser?.currentUser]}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <div></div>
          </div>
        </header>
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoadingLoginUser ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <VscCloudDownload size={75} />
                    <p>Fetching request...</p>
                  </td>
                </tr>
              ) : displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((row, i) => (
                  <tr className="data-table-row" key={i}>
                    <td className="table-datacell datatype-string">
                      <AccountCircle />
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row?.firstName}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {row?.LastName}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row?.email}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row?.phoneNumber}
                    </td>

                    <td className="table-datacell datatype-string">
                      {row?.role}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      <button className="severity-low">
                        {row?.isEnabled === true ? "Active" : "Deactivated"}
                      </button>
                    </td>
                    <td className="table-datacell datatype-string">
                      <button className="admin-btn-progress">
                        {" "}
                        EDIT USER{" "}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <footer className="main-table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={active}
              entriesperpage={entriesperpage}
              Total={"Applicant"}
            />
          </div>
        </footer>
      </section>
    </div>
  );
};


export default RoleTable
